import { MatSpinner } from '@angular/material/progress-spinner';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalSigninComponent } from './modal-signin/modal-signin.component';


@Component({
    selector: 'app-signin',
    imports: [MatSpinner],
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.css']
})

export class SigninComponent implements OnInit, OnDestroy {

  labo : any = null;
  constructor(){
    this.labo = JSON.parse(localStorage.getItem('currentLabo'));
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
      setTimeout(() => {
        this.openModalSignin('0ms', '10ms')
      }, 2000);
  }

  readonly dialog = inject(MatDialog);

  openModalSignin(enterAnimationDuration : string, exitAnimationDuration : string) : void{
    this.dialog.open(ModalSigninComponent, {
      enterAnimationDuration,
      exitAnimationDuration,
      disableClose: true,
      position : { top : `8%`, left : `10%`, bottom : ``, right : ``}
    })
  }

  ngOnDestroy(): void {
    this.dialog.closeAll()
  }
}
